/*eslint unicode-bom: ["error", "always"]*/
export const styleTextLink = { cursor: "pointer", color: "blue" };

export const styleBookmarkRow = { backgroundColor: "#FFE9A3" };
export const style_next_executed_fail_Row = { color: "#FFA5A5" };
export const styleLoopDetectedBookmarkRow = { backgroundColor: "#FFE9A3", color: "#FF9090" };
export const styleLoopDetectedRow = { color: "#FF9090" };
export const styleInvalidRow = { backgroundColor: "#FF9090" };